export class OcaenFreightRateRequest{
    id:number
    linerId:number
    otherCharge:number
    basicPrice:number
    createdUser:string
    updatedUser:string
    isActive:boolean
    versionFlag:number
    createdAt:Date
    constructor(
    id:number,
    linerId:number,
    otherCharge:number,
    basicPrice:number,
    createdUser:string,
    updatedUser:string,
    isActive:boolean,
    versionFlag:number,
    createdAt:Date

    ){
       this.id = id
       this.createdUser = createdUser
       this.updatedUser = updatedUser
       this.isActive = isActive
       this.versionFlag = versionFlag
       this.createdAt = createdAt
       this.basicPrice= basicPrice
       this.linerId = linerId
       this.otherCharge = otherCharge
    }
}
export class OcaenFreightRateRequestDto{
    data:OcaenFreightRateRequest[]
    user:string
    constructor(
        data:OcaenFreightRateRequest[],
        user:string
    ){
this.data = data
this.user = user
    }
}
